"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent, popupViewed } from "@/lib/mixpanels/mixpanel";
import { DialogButton, DialogTitle, Typography } from "@bookips/sds";
import { useDialogStore } from "src/store/useDialogStore";
const LICENSE_USE_DIALOG_ID = "license-use-dialog";
/** 환불 규정 내용 */ const REFUND_POLICY = [
    "자료를 열람하거나 다운로드하면 이용이 시작된 것으로 간주하며, 환불 시 이용 건당 5,000원이 결제 금액에서 차감됩니다.",
    "환불은 결제일로부터 7일 이내, 자료 미이용 시에만 전액 가능합니다. (7일 경과 시 환불 불가)",
    "특정 프로모션 상품의 경우, 해당 상품 페이지에 안내된 별도 환불 규정이 이 공통 규정보다 우선 적용됩니다."
];
/** 이용 안내 내용 */ const USAGE_GUIDE = [
    "쏠북패스가 제공하는 모든 오리지널 콘텐츠는 수업과 학습 용도로만 이용해 주세요.",
    "1인 1계정 이용이 원칙이며, 타인과 계정을 공유하거나 자료를 무단으로 배포\xb7재판매하는 행위는 엄격히 금지됩니다.",
    "모든 자료에는 유출 방지를 위한 디지털 워터마크가 포함되어 있으며 실시간 모니터링이 진행됩니다."
];
/** 정보 카드 내용 컴포넌트 */ const LicenseUseInfoContent = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "mx-7 mb-0 max-sm:mx-5",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "bg-gray-0 flex flex-col gap-5 rounded-md px-3 py-5",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            className: "text-primary",
                            children: "환불 규정"
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            className: "list-disc pl-6",
                            children: REFUND_POLICY.map((text, index)=>/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body1",
                                        className: "text-secondary",
                                        children: text
                                    })
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            className: "text-primary",
                            children: "이용 안내"
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            className: "list-disc pl-6",
                            children: USAGE_GUIDE.map((text, index)=>/*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body1",
                                        className: "text-secondary",
                                        children: text
                                    })
                                }, index))
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * 이용권 첫 사용 안내 다이얼로그 훅
 * - 이용권으로 처음 자료를 열람/다운로드 할 때 안내 다이얼로그 표시
 */ export const useLicenseUseDialog = ()=>{
    const { open , close  } = useDialogStore();
    /**
   * 이용권 이용 안내 다이얼로그 열기
   * @param onConfirm 확인 버튼 클릭 시 콜백
   * @param position 믹스패널 Position 프로퍼티 ('에디션 카테고리' | '시스템 카테고리')
   */ const openLicenseUseDialog = function(onConfirm) {
        let position = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "에디션 카테고리", onCancel = arguments.length > 2 ? arguments[2] : void 0;
        const popupTitle = "자료 이용 전 아래 사항을 꼭 확인해주세요.";
        const body = [
            ...REFUND_POLICY,
            ...USAGE_GUIDE
        ].join(" ");
        // mx-425: Popup Viewed
        popupViewed({
            Position: position,
            Type: "자료 이용 전 환불 규정 안내",
            Title: popupTitle,
            Body: body
        });
        open({
            id: LICENSE_USE_DIALOG_ID,
            type: "custom",
            props: {
                title: /*#__PURE__*/ _jsx(DialogTitle, {
                    title: popupTitle,
                    className: "mx-7 mt-7 max-sm:mx-5 max-sm:mt-5"
                }),
                children: /*#__PURE__*/ _jsx(LicenseUseInfoContent, {}),
                scroll: true,
                footer: /*#__PURE__*/ _jsx(DialogButton, {
                    confirmText: "이용",
                    cancelText: "취소",
                    onConfirm: ()=>{
                        close(LICENSE_USE_DIALOG_ID);
                        onConfirm();
                    },
                    onCancel: ()=>{
                        mixpanelEvent("Popup Button Clicked", {
                            "Position": position,
                            "Popup Type": "자료 이용 전 환불 규정 안내",
                            "Popup Title": popupTitle,
                            "Title": popupTitle,
                            "Body": body,
                            "Button Name": "취소",
                            "Button Url": null
                        });
                        close(LICENSE_USE_DIALOG_ID);
                        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                    },
                    classes: {
                        root: "max-sm:px-5 max-sm:pb-5"
                    }
                }),
                contentProps: {
                    onInteractOutside: ()=>{
                        close(LICENSE_USE_DIALOG_ID);
                        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                    }
                },
                classes: {
                    contentWrapper: "max-w-[520px] max-sm:w-[calc(100vw-40px)]"
                }
            }
        });
    };
    const closeDialog = ()=>{
        close(LICENSE_USE_DIALOG_ID);
    };
    return {
        openLicenseUseDialog,
        closeDialog
    };
};
